import type { APIClient } from '../apiClient';
import createJourneysAPI from './journeys/journeysApi';
import createLibraryAPI from './library/libraryApi';
import createWorkflowsAPI from './workflows/workflowsApi';


export type API = ReturnType<typeof createModuleAPIs>;
export default function createModuleAPIs(apiClient: APIClient) {
  // add all module APIs here:
  return {
    journeys: createJourneysAPI(apiClient),
    library: createLibraryAPI(apiClient),
    workflows: createWorkflowsAPI(apiClient),
  };
}

